// extracted by mini-css-extract-plugin
export var dataCell = "_p3-2";
export var dataRow = "_p3-0";
export var headerRow = "_p3-1";